import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import "./UserList.css" 

const SubCategporyList = () => {
    document.title = "Sub Categorys | Uma Classes";

    const [subCategorys, setSubCategorys] = useState([]);
    const [modal, setModal] = useState(false);
    const [CategoryIdToDelete, setCategoryIdToDelete] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSubCategorys = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get('https://uma.aasmo.in/api/admin/getall-subcategory', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setSubCategorys(response || []);
            } catch (error) {
                console.error('Error fetching SubCategorys:', error);
            }
        };

        fetchSubCategorys();
    }, []);

    const toggleModal = () => setModal(!modal);

    const handleDelete = (CategoryId) => {
        setCategoryIdToDelete(CategoryId);
        toggleModal();
    };

    const confirmDelete = async () => {
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`https://uma.aasmo.in/api/admin/delete-subcategory/${CategoryIdToDelete}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setSubCategorys(subCategorys.filter(Category => Category._id !== CategoryIdToDelete));
            toggleModal();
        } catch (error) {
            console.error('Error deleting Category:', error);
        }
    };

    const handleEdit = (CategoryId) => {
        navigate(`/edit-subcategory/${CategoryId}`);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title="Courses" breadcrumbItem="All" />

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <h4 className="card-title">All SubCategorys</h4>
                                    <p className="card-title-desc">Below are all SubCategorys</p>

                                    <div className="table-responsive">
                                        <table className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Category Name</th>
                                                    <th>Sub Category Name</th>
                                                    <th>Date</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {subCategorys.length > 0 ? (
                                                    subCategorys.map((Category, index) => (
                                                        <tr key={Category._id}>
                                                            <th scope="row">{index + 1}</th>
                                                            <td className="nowrap">{Category?.category?.name || "N/A"}</td>
                                                            <td className="nowrap">{Category?.name || "N/A"}</td>

                                                            <td className="nowrap">{moment(Category.createdAt).format('MMMM Do, YYYY')}</td>

                                                            <td>
                                                                <i className="dripicons-document-edit" onClick={() => handleEdit(Category._id)} />{" "}
                                                                <i className="dripicons-document-delete" onClick={() => handleDelete(Category._id)} />{" "}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="10" className="text-center">No Sub Categorys found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                {/* Delete Confirmation Modal */}
                <Modal isOpen={modal} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>Confirm Deletion</ModalHeader>
                    <ModalBody>
                        Are you sure you want to delete this Category?
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggleModal}>Cancel</Button>
                        <Button color="danger" onClick={confirmDelete}>Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </React.Fragment>
    );
};

export default SubCategporyList;
